import { useContext, useState } from "react";
import BurguerMobile from "../../../../_+_Portal/components/Genericos/BurguerMobile/BurguerMobile";
import HeaderbarHome from "../../../../_+_Portal/components/Genericos/HeaderbarHome/HeaderbarHome";
import { ContainerChildren } from "./localStyle";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { getLocalStorage } from "global/utils/safeJsonParse";

const Layout = ({ children, time, timerGlobal, flgTimerGlobal }) => {
  // Header Bar copiado
  const [showBurguerMobile, setShowBurguerMobile] = useState(false);
  const { pasoState } = useContext(AutocheckContext);

  const config = getLocalStorage("config", {});
  const tiempoDeEsperaCheckin = Number(config?.tiempoDeEsperaCheckin);

  const onShowBurguerHandle = () => {
    setShowBurguerMobile(true);
  };
  const onCloseBurguerMobile = (type) => {
    if (type === "open") setShowBurguerMobile(true);
    else setShowBurguerMobile(false);
  };
  return (
    <>
      {/* HEADER BAR DE PORTAL  */}
      <BurguerMobile
        onCloseBurguerMobile={onCloseBurguerMobile}
        showBurguerMobile={showBurguerMobile}
      />
      <HeaderbarHome
        onShowBurguerHandle={onShowBurguerHandle}
        time={time ? time : tiempoDeEsperaCheckin}
        timerGlobal={(timer) => timerGlobal(timer)}
        flgTimerGlobal={flgTimerGlobal}
        desactivarTimer={
          pasoState.paso.data === "SubirOrden" ||
          pasoState.paso.data === "MercadoPagoQRDesktop" ||
          pasoState.paso.data === "AbonarMP" ||
          pasoState.paso.data === "ValidacionCoberturaLabo" ||
          pasoState.paso.data === "ValidarCobertura"
        }
      />
      <ContainerChildren>{children}</ContainerChildren>
    </>
  );
};

export default Layout;
